import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox" ]

  downloanExclusiveExample() {
    const exclusive_link = document.getElementById('exclusive-link');
    exclusive_link.setAttribute('href', `/admin/promotions/download_example?download_example_type=eslite_sn`)
  }

  uploadExclusiveItems(event) {
    // 判斷畫面上的items清單是否有顯示，決定是否需顯示table表頭。
    let table = document.getElementById('exclusive_items_table');
    let targetDisplay;
    if (table) {
      targetDisplay = true;
    } else {
      targetDisplay = false;
    }
    let targetDisplayField = document.createElement("input");
    targetDisplayField.type = "hidden";
    targetDisplayField.name = "target_display";
    targetDisplayField.value = targetDisplay;
    event.target.appendChild(targetDisplayField);

    // 如果要加入的選項已經在項目table裡面，api那邊會濾掉不撈重複的項目顯示在畫面上。
    let existedItems = document.querySelectorAll(".exclusive_item_checkbox")
    var values = [];

    existedItems.forEach(function(item) {
      values.push(item.value);
    });

    let exsitedItemsField = document.createElement("input");
    exsitedItemsField.type = "hidden";
    exsitedItemsField.name = "exsisted_items";
    exsitedItemsField.value = values;
    event.target.appendChild(exsitedItemsField);
  }

  handleNone(event) {
    if (event.target.checked) {
      event.preventDefault();
      // 隱藏排除項目的table並刪除所有combo_offer form裡面的排除項目hidden_field
      const itemTable = document.querySelector("#exclusive_items_div");
      const removeBtn = document.querySelector("#exclusive_btn");
      const exclusiveHiddenFields = document.querySelector("#hidden-exclusive-object-key");
      const exclusiveKeys = exclusiveHiddenFields.querySelectorAll(`input[type="hidden"]`);
      const checkboxes = document.querySelectorAll(".exclusive_item_checkbox");

      // 刪除排除項目table裡面所有內容
      checkboxes.forEach(checkbox => {
        const itemElement = checkbox.closest("tr");
        itemElement.remove();
      });

      // 刪除所有排除項目的hidden_field
      if (itemTable) {
        itemTable.classList.add("d-none");
        exclusiveKeys.forEach((element) => {
          element.parentNode.removeChild(element);
        });
      }

      // 把顯示items的筆數歸零
      let itemsSizeSpan = document.getElementById("exclusive_items_size")
      itemsSizeSpan.innerText = "共0筆"
    }
  }

  checkAll(event) {
    const checkboxes = document.querySelectorAll(".exclusive_item_checkbox");
    checkboxes.forEach(checkbox => {
        checkbox.checked = event.target.checked;
    });
  }

  removeItem(event) {
    event.preventDefault();
    const itemTable = this.element.querySelector("#exclusive_items_table");
    const checkboxes = this.element.querySelectorAll(".exclusive_item_checkbox");
    const checkAll = this.element.querySelector("#exclusive-check-all")
    if (checkboxes.length == 1 || checkAll.checked) {
      itemTable.remove()
    }

    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const itemElement = checkbox.closest("tr");

        // 找到並刪除對應的 hidden input
        const itemValue = itemElement.dataset.value;
        const exclusiveKeys = document.getElementById('hidden-exclusive-object-key');
        const hiddenInput = exclusiveKeys.querySelector(`input[value="${itemValue}"]`);
        if (hiddenInput) {
          hiddenInput.remove();
        }

        itemElement.remove();
      }
    });

    // 處理顯示的排除項目筆數
    // 現在顯示的筆數 - 勾選移除的筆數 = 新的筆數
    let itemsSizeSpan = document.getElementById("exclusive_items_size")
    var checkedSize = 0;
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        checkedSize++;
      }
    }

    let newSize = checkboxes.length - checkedSize
    let newContent = itemsSizeSpan.innerText.replace(checkboxes.length, newSize)
    itemsSizeSpan.innerText = newContent
  }

  updateCheckAll(event) {
    const checkAll = this.element.querySelector("#exclusive-check-all")
    if (!event.target.checked && checkAll.checked) {
      checkAll.checked = false
    }
  }
}
